export default __webpack_public_path__ + "static/media/usdc.c4477cfc.png";